import React, { useContext } from 'react';
import { useTeams } from '../../hooks/team';
import { useSeasons } from '../../hooks/seasons';
import { ROUNDS } from '../../constants/matches';
import { DataContext } from '../../context/data-context';

function MatchesListHeader({
  setSeason,
  season,
  setTeam,
  team,
  setRound,
  round,
  hideRoundFilter,
}) {
  const { league } = useContext(DataContext);
  const [teams, loadingTeams] = useTeams();
  const [seasons, loadingSeasons] = useSeasons('desc');

  if (loadingTeams || loadingSeasons) return <div />;

  return (
    <div className="data-container__header">
      <div className="row px-4 pt-3 pb-2">
        <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
          <p className="heading-h6 mb-1">Säsong</p>
          <select
            value={season}
            onChange={(e) => setSeason(e.target.value)}
            className="select"
          >
            {seasons?.map((s) => (
              <option>{s.configSeasonStartYear}</option>
            ))}
          </select>
        </div>
        {!hideRoundFilter && (
          <div className="col-12 col-md px-md-1 mb-3 mb-md-0">
            <p className="heading-h6 mb-1">Omgång</p>
            <select
              defaultValue="all"
              value={round}
              onChange={(e) => setRound(e.target.value)}
              className="select"
            >
              <option value="all">Alla omgångar</option>
              {ROUNDS[league].map((r) => (
                <option value={r}>{`OMGÅNG ${r}`}</option>
              ))}
            </select>
          </div>
        )}
        <div className="col-12 col-md ps-md-1 mb-3 mb-md-0">
          <p className="heading-h6 mb-1">Filtera på lag</p>
          <select
            defaultValue="all"
            value={team}
            onChange={(e) => setTeam(e.target.value)}
            className="select"
          >
            <option value="all">Alla lag</option>
            {teams?.map((t) => (
              <option value={t?.abbrv}>{t?.name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default MatchesListHeader;
